const t = require('app/scripts/views/internal/teacupWithHelpers').teacupWithHelpers(
  'invitee_orientation',
);
const { currentLocale } = require('@trello/locale');

module.exports = t.renderable(function () {
  const membersLocaleLink = () => {
    let link;
    if (currentLocale === 'en-US') {
      link = 'https://trello.com/en/guide';
    } else {
      link = `https://trello.com/${currentLocale}/guide`;
    }
    return link;
  };

  t.div('.invitee-orientation-message-container.arrow', function () {
    t.a(
      '.js-close-orientation.pop-over-header-close-btn.close-invitee-orientation.icon-sm.icon-close',
    );

    t.h1(() => {
      t.format('welcome-to-trello-wave');
    });

    t.div('.invitee-orientation-text.u-clearfix', function () {
      t.p(() => t.format('main-message'));
      t.li(() => t.span(() => t.format('main-message-list1')));
      t.li(() => t.span(() => t.format('main-message-list2')));
      t.li(() => t.span(() => t.format('main-message-list3')));

      t.p('.trello-basics', () =>
        t.span(() => {
          t.format('main-trello-basics');
        }),
      );

      t.a(
        '.nch-button.nch-button--primary.full.guide-button',
        { href: membersLocaleLink(), target: '_blank' },
        () => t.format('getting-started-button'),
      );
    });
  });

  t.div('.invitee-orientation-avatar-container', function () {
    t.img('.invitee-orientation-avatar', {
      src: require('resources/images/corner-taco.svg'),
    });
  });
});
